module.exports = __webpack_public_path__ + "img/176.74b01855.jpg";